// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"CheckBox_checkBoxContainer__hsCSu","formCheckMod":"CheckBox_formCheckMod__YxsIR"};